import {Component, Input, OnInit, EventEmitter, ViewChild} from '@angular/core';
import {trigger, state, style, transition, animate} from '@angular/animations';
import {MenuItem} from 'primeng/primeng';
import {AppComponent} from './app.component';
import {UserService} from './services/user.service';

@Component({
    selector: 'app-menu',
    template: `
        <ul app-submenu [item]="userService.model" root="true" class="layout-menu layout-main-menu clearfix" [reset]="reset" visible="true"></ul>
    `
})
export class AppMenuComponent implements OnInit {

    @Input() reset: boolean;

    //model: any[];

    constructor(public app: AppComponent,public userService : UserService) {}

    ngOnInit() {
      /*this.model = [];
      this.model.push({label: 'Tiempo Real', icon: 'fa fa-fw fa-globe', routerLink: ['/home']});
      if(this.userService.userLoged.idProfile == 1){
        this.model.push({
            label: 'Configuraciones', icon: 'fa fa-fw fa-cogs',
            items: [
                {label: 'Protocolos', icon: 'fa fa-fw fa-barcode', routerLink: ['/protocol']},
                {label: 'Tipos de Equipo', icon: 'fa fa-fw fa-wrench', routerLink: ['/deviceType']},
                {label: 'Empresas', icon: 'fa fa-fw fa-building', routerLink: ['/company']},
                {label: 'Perfiles', icon: 'fa fa-fw fa-users', routerLink: ['/profile']}
            ]
        });
        this.model.push({
            label: 'Administración', icon: 'fa fa-fw fa-laptop',
            items: [
                {label: 'Usuarios', icon: 'fa fa-fw fa-user', routerLink: ['/user']},
                {label: 'Equipos', icon: 'fa fa-fw fa-car', routerLink: ['/device']},
                {label: 'Usuarios - Equipos', icon: 'fa fa-fw fa-wrench', routerLink: ['/userDevice']},
                {label: 'Geocercas', icon: 'fa fa-fw fa-certificate', routerLink: ['/geofence']},
                {label: 'Envio de Reportes', icon: 'fa fa-fw fa-envelope', routerLink: ['/schedulingReport']}
            ]
        });
      }else{
        this.model.push({
            label: 'Administración', icon: 'fa fa-fw fa-laptop',
            items: [
                {label: 'Equipos', icon: 'fa fa-fw fa-car', routerLink: ['/device']},
                {label: 'Geocercas', icon: 'fa fa-fw fa-certificate', routerLink: ['/geofence']},
                {label: 'Envio de Reportes', icon: 'fa fa-fw fa-envelope', routerLink: ['/schedulingReport']}
            ]
        });
      }
      this.model.push({
          label: 'Reportes', icon: 'fa fa-fw fa-folder-open-o',
          items: [
              {label: 'Historial Posiciones', icon: 'fa fa-fw fa-map', routerLink: ['/positionHistory']},
              {label: 'Reporte GPS', icon: 'fa fa-fw fa-file', routerLink: ['/positionReport']},
              {label: 'Reporte de Viajes', icon: 'fa fa-fw fa-exchange', routerLink: ['/travelReport']},
              {label: 'Tiempos Estacionados', icon: 'fa fa-fw fa-stop-circle', routerLink: ['/stoppedTimeReport']},
              {label: 'Distancia Recorrida', icon: 'fa fa-fw fa-location-arrow', routerLink: ['/distanceTraveledReport']},
              {label: 'Consumo Combustible', icon: 'fa fa-fw fa-thermometer-half', routerLink: ['/fuelConsumptionReport']},
              {label: 'Exceso de Velocidad', icon: 'fa fa-fw fa-tachometer', routerLink: ['/excessSpeedReport']},
              {label: 'Reporte de Ocio', icon: 'fa fa-fw fa-hand-paper-o', routerLink: ['/leisureReport']},
              {label: 'Reporte de Estado', icon: 'fa fa-fw fa-check', routerLink: ['/statusReport']},
              {label: 'Reporte de Alarmas', icon: 'fa fa-fw fa-warning', routerLink: ['/alarmReport']},
              {label: 'Fuera de Horario', icon: 'fa fa-fw fa-clock-o', routerLink: ['/drivingOutsideHoursReport']}
          ]
      });*/
    }

    changeTheme(theme: string) {
        const themeLink: HTMLLinkElement = <HTMLLinkElement> document.getElementById('theme-css');

        themeLink.href = 'assets/theme/theme-' + theme + '.css';
    }

    changeLayout(layout: string, special?: boolean) {
        const layoutLink: HTMLLinkElement = <HTMLLinkElement> document.getElementById('layout-css');
        layoutLink.href = 'assets/layout/css/layout-' + layout + '.css';

        if (special) {
            this.app.darkMenu = true;
        }
    }
}

@Component({
  /* tslint:disable:component-selector */
    selector: '[app-submenu]',
  /* tslint:enable:component-selector */
    template: `
        <ng-template ngFor let-child let-i="index" [ngForOf]="(root ? item : item.items)">
            <li [ngClass]="{'active-menuitem': isActive(i)}" [class]="child.badgeStyleClass" *ngIf="child.visible === false ? false : true">
                <a [href]="child.url||'#'" (click)="itemClick($event,child,i)" (mouseenter)="onMouseEnter(i)"
                   class="ripplelink" *ngIf="!child.routerLink"
                    [attr.tabindex]="!visible ? '-1' : null" [attr.target]="child.target">
                    <i [ngClass]="child.icon"></i><span>{{child.label}}</span>
                    <i class="fa fa-fw fa-angle-down menuitem-toggle-icon" *ngIf="child.items"></i>
                    <span class="menuitem-badge" *ngIf="child.badge">{{child.badge}}</span>
                </a>

                <a (click)="itemClick($event,child,i)" (mouseenter)="onMouseEnter(i)" class="ripplelink" *ngIf="child.routerLink"
                    [routerLink]="child.routerLink" routerLinkActive="active-menuitem-routerlink"
                   [routerLinkActiveOptions]="{exact: true}" [attr.tabindex]="!visible ? '-1' : null" [attr.target]="child.target">
                    <i [ngClass]="child.icon"></i><span>{{child.label}}</span>
                    <i class="fa fa-fw fa-angle-down menuitem-toggle-icon" *ngIf="child.items"></i>
                    <span class="menuitem-badge" *ngIf="child.badge">{{child.badge}}</span>
                </a>
                <div class="layout-menu-tooltip">
                    <div class="layout-menu-tooltip-arrow"></div>
                    <div class="layout-menu-tooltip-text">{{child.label}}</div>
                </div>
                <div class="submenu-arrow" *ngIf="child.items"></div>
                <ul app-submenu [item]="child" *ngIf="child.items" [visible]="isActive(i)" [reset]="reset"
                    [@children]="(app.isSlim()||app.isHorizontal())&&root ? isActive(i) ?
                     'visible' : 'hidden' : isActive(i) ? 'visibleAnimated' : 'hiddenAnimated'"></ul>
            </li>
        </ng-template>
    `,
    animations: [
        trigger('children', [
            state('hiddenAnimated', style({
                height: '0px'
            })),
            state('visibleAnimated', style({
                height: '*'
            })),
            state('visible', style({
                display: 'block'
            })),
            state('hidden', style({
                display: 'none'
            })),
            transition('visibleAnimated => hiddenAnimated', animate('400ms cubic-bezier(0.86, 0, 0.07, 1)')),
            transition('hiddenAnimated => visibleAnimated', animate('400ms cubic-bezier(0.86, 0, 0.07, 1)'))
        ])
    ]
})
export class AppSubMenuComponent {

    @Input() item: MenuItem;

    @Input() root: boolean;

    @Input() visible: boolean;

    _reset: boolean;

    activeIndex: number;

    constructor(public app: AppComponent) {}

    itemClick(event: Event, item: MenuItem, index: number) {
        if (this.root) {
            this.app.menuHoverActive = !this.app.menuHoverActive;
        }

        // avoid processing disabled items
        if (item.disabled) {
            event.preventDefault();
            return true;
        }

        // activate current item and deactivate active sibling if any
        this.activeIndex = (this.activeIndex === index) ? null : index;

        // execute command
        if (item.command) {
            item.command({originalEvent: event, item: item});
        }

        // prevent hash change
        if (item.items || (!item.url && !item.routerLink)) {
            setTimeout(() => {
                this.app.layoutMenuScrollerViewChild.moveBar();
            }, 450);
            event.preventDefault();
        }

        // hide menu
        if (!item.items) {
            if (this.app.isHorizontal() || this.app.isSlim()) {
                this.app.resetMenu = true; } else {
                this.app.resetMenu = false; }

            this.app.overlayMenuActive = false;
            this.app.staticMenuMobileActive = false;
            this.app.menuHoverActive = !this.app.menuHoverActive;
        }
    }

    onMouseEnter(index: number) {
        if (this.root && this.app.menuHoverActive && (this.app.isHorizontal() || this.app.isSlim())
            && !this.app.isMobile() && !this.app.isTablet()) {
            this.activeIndex = index;
        }
    }

    isActive(index: number): boolean {
        return this.activeIndex === index;
    }

    @Input() get reset(): boolean {
        return this._reset;
    }

    set reset(val: boolean) {
        this._reset = val;

        if (this._reset && (this.app.isHorizontal() || this.app.isSlim())) {
            this.activeIndex = null;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/app.menu.component.ts